import { GifService } from "../../infrastructure";
import { IGifService } from "../services";

class GetRandomGifUseCase {
  private _service: IGifService;

  constructor({ service }: { service: IGifService }) {
    this._service = service;
  }

  async execute() {
    return this._service.execute();
  }
}

const GetRandomGifUseCaseInstance = new GetRandomGifUseCase({
  service: new GifService(),
});

export default GetRandomGifUseCaseInstance;
